export default (theme) => ({
    root: {
        position: 'relative',
    },
    parent: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '0px 8px',
        textDecoration: 'none',
        borderRadius: '8px',
        transition: 'all .2s ease',
        minWidth: 40,
        cursor: 'pointer',
        '&:not($parentActive):hover, &$parentOpen': {
            backgroundColor: theme.colors.grey[700],
        },
    },
    parentActive: {
        backgroundColor: theme.colors.grey[600],
    },
    parentExpanded: {
        margin: '0px 8px',
    },
    icon: {
        width: 40,
        height: 40,
        padding: '12px 8px',
        flexShrink: 0,
    },
    label: {
        ...theme.typography.button,
        position: 'absolute',
        zIndex: 2,
        left: 40,
        width: '100%',
        maxWidth: 'calc(100% - 50px)',
        color: theme.colors.transparent,
        display: 'inline-block',
        opacity: 0,
        willChange: 'opacity',
        whiteSpace: 'nowrap',
        transition: 'opacity .4s linear',
    },
    labelExpanded: {
        opacity: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: theme.colors.textDark.primary,
    },
    caret: {
        position: 'absolute',
        right: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
        opacity: 0,
        transition: 'opacity .4s linear',
        color: theme.colors.textDark.primary,
        flexShrink: 0,
    },
    caretExpanded: {
        opacity: 1,
    },
    flyout: {
        position: 'fixed',
        zIndex: 1000,
        minWidth: 200,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: theme.colors.background.gray900,
        borderRadius: 8,
        padding: 16,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    },
    submenuItem: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textDecoration: 'none',
        borderRadius: '8px',
        margin: 0,
        transition: 'all .2s ease',
        cursor: 'pointer',
        minHeight: 40,
        '&:not($submenuItemActive):hover': {
            backgroundColor: theme.colors.grey[700],
        },
    },
    submenuItemActive: {
        backgroundColor: theme.colors.grey[600],
    },
    submenuIcon: {
        width: 40,
        height: 40,
        padding: '12px 8px',
        flexShrink: 0,
    },
    submenuLabel: {
        ...theme.typography.button,
        color: theme.colors.textDark.primary,
        whiteSpace: 'nowrap',
        paddingRight: 16,
    },
});
